module.exports = __webpack_public_path__ + "img/suitcase.84d794d9.svg";